import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USERS_STATE_KEY } from '../definitions/users.definitions';
import { usersAdapter, UsersState } from '../reducers/users.reducers';
import { UserListItem } from '../../../shared/models';

export namespace UsersSelectors {
  export const getUsersFeatureState = createFeatureSelector<UsersState>(USERS_STATE_KEY);

  export const {
    selectAll: getUsers,
    selectIds: getUserIds,
    selectEntities: getUsersMap,
  } = usersAdapter.getSelectors(getUsersFeatureState);

  export const getSelectedUserId = createSelector(
    getUsersFeatureState,
    (state) => state.selectedUserId
  );

  export const getisUsersFetched = createSelector(getUsersFeatureState, (state) => state.isFetched);

  export const getSelectedUser = createSelector(
    getUsersMap,
    getSelectedUserId,
    (users, selectedUserId) => users && users[selectedUserId]
  );

  export const getUserMonitoredUserIds = createSelector(
    getUsersFeatureState,
    (state) => state.monitoredUsers
  );

  export const getMonitoringUserIds = createSelector(
    getUsersFeatureState,
    (state) => state.monitoringUsers
  );

  export const getSubAdvisorIds = createSelector(
    getUsersFeatureState,
    (state) => state.subAdvisors
  );

  export const getUserMonitoredUsers = createSelector(
    getUsersMap,
    getUserMonitoredUserIds,
    (entities, ids) => ids.map((id) => entities[id]).filter((u): u is UserListItem => !!u)
  );

  export const getMonitoringUsers = createSelector(
    getUsersMap,
    getMonitoringUserIds,
    (entities, ids) => ids.map((id) => entities[id]).filter((u): u is UserListItem => !!u)
  );

  export const getSubAdvisors = createSelector(getUsersMap, getSubAdvisorIds, (entities, ids) =>
    ids.map((id) => entities[id]).filter((u): u is UserListItem => !!u)
  );

  export const getUserDetails = createSelector(getUsersFeatureState, (state) => state.userDetails);

  export const selectUsersState = createFeatureSelector<UsersState>('users');

  export const selectPendingInvitationEmail = createSelector(
    selectUsersState,
    (s) => s.pendingInvitationEmail
  );
}
